module.exports = __webpack_public_path__ + "static/media/loader.c9049653.gif";